import { GetStaticPropsContext } from 'next'
import Head from 'next/head'
import { Layout } from '~/components/Layout'
import { ExhibitorStory, ExhibitorsProvider, fetchExhibitor, fetchExhibitors } from '~/features/exhibitors'
import { ExhibitorProvider } from '~/features/exhibitors/Exhibitor'
import { ExhibitorScreen } from '~/features/exhibitors/ExhibitorScreen'
import { resizeImage } from '~/storyblok/resizeImage'

type Props = {
  exhibitors?: ExhibitorStory[]
  exhibitor: ExhibitorStory
}

export default function ExhibitorPage({ exhibitor, exhibitors }: Props) {
  const title = `${exhibitor.name} | 12. Berufs- & Bildungstage 2026 | Next-Step - Bildung. Beruf. Liechtenstein`
  const shareImage = resizeImage(exhibitor.content.image, { width: 1200, height: 1200 })

  return (
    <ExhibitorsProvider exhibitors={exhibitors}>
      <ExhibitorProvider exhibitor={exhibitor}>
        <Head>
          <title>{title}</title>
          <meta
            name="description"
            content="Bereits zum 12. Mal wird am 25./26. September 2026 im SAL in Schaan die next-step Berufs- & Bildungstage durchgeführt."
          />
          <meta property="og:url" content={`https://digital.next-step.li/aussteller/${exhibitor.slug}`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title} />
          {shareImage && <meta property="og:image" content={shareImage.url} />}
        </Head>
        <Layout>
          <ExhibitorScreen exhibitor={exhibitor} />
        </Layout>
      </ExhibitorProvider>
    </ExhibitorsProvider>
  )
}

export async function getStaticProps({ params, preview = false }: GetStaticPropsContext) {
  const slug = params?.slug ? String(params.slug) : ''
  const exhibitor = await fetchExhibitor(slug, preview)
  const exhibitors = (await fetchExhibitors(preview)) || []

  if (!exhibitor) {
    return {
      notFound: true,
    }
  }

  return {
    props: { exhibitor, exhibitors },
  }
}

// TODO: Fetch all published pages, see https://github.com/storyblok/react-next-boilerplate/blob/main/pages/%5B...slug%5D.js#L57
export async function getStaticPaths() {
  const exhibitors = (await fetchExhibitors(false)) || []
  const paths = exhibitors.map((exhibitor) => {
    return { params: { slug: exhibitor.slug } }
  })

  return {
    paths,
    fallback: 'blocking',
  }
}
